import script from "./ProfileProfessionalLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileProfessionalLinks.vue?vue&type=script&setup=true&lang=js"

import "./ProfileProfessionalLinks.vue?vue&type=style&index=0&id=689a2a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689a2a98"]])

export default __exports__